'use client';
import React, { useState } from 'react';

const navItems = [
  { label: 'Home', href: '#home' },
  { label: 'About Us', href: '#about' },
  { label: 'Services', href: '#services' },
  { label: 'Why Us', href: '#why-us' },
  { label: 'Contact', href: '#contact' },
];

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [activeItem, setActiveItem] = useState('Home');

  return (
    <div style={{ width: '100%', backgroundColor: '#fff', padding: '10px 20px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>
      <div style={{ maxWidth: '1140px', margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        {/* Logo */}
        <a href="#home" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '10px' }}>
          <div style={{
            width: '44px', height: '44px', borderRadius: '50%',
            backgroundColor: '#0e6585', display: 'flex', alignItems: 'center', justifyContent: 'center',
            flexShrink: 0
          }}>
            <span style={{ color: '#fff', fontFamily: 'Lato, sans-serif', fontWeight: 900, fontSize: '22px' }}>G</span>
          </div>
          <div>
            <div style={{ fontFamily: 'Lato, sans-serif', fontWeight: 900, fontSize: '16px', color: '#0e6585', lineHeight: 1.1, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
              Gottscho Printing
            </div>
            <div style={{ fontFamily: 'Lato, sans-serif', fontWeight: 400, fontSize: '11px', color: '#777', textTransform: 'uppercase', letterSpacing: '1px' }}>
              Systems, Inc.
            </div>
          </div>
        </a>

        {/* Desktop Nav */}
        <nav style={{ display: 'flex', alignItems: 'center', gap: '0' }} className="desktop-nav">
          {navItems?.map((item) => (
            <a
              key={item?.label}
              href={item?.href}
              onClick={() => setActiveItem(item?.label)}
              style={{
                padding: '17px 12px',
                fontSize: '12px',
                letterSpacing: '1px',
                textDecoration: 'none',
                color: activeItem === item?.label ? '#0e6585' : '#777',
                fontWeight: 700,
                textTransform: 'uppercase',
                fontFamily: 'Lato, sans-serif',
                transition: 'color 0.2s',
                borderBottom: activeItem === item?.label ? '2px solid #0e6585' : '2px solid transparent',
              }}
              className="nav-link"
            >
              {item?.label}
            </a>
          ))}
        </nav>

        {/* Mobile Hamburger */}
        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          style={{
            display: 'none',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: '8px',
            color: '#777',
          }}
          className="mobile-menu-btn"
          aria-label="Toggle menu"
        >
          <div style={{ width: '22px', height: '2px', backgroundColor: '#777', marginBottom: '5px', transition: '0.3s' }}></div>
          <div style={{ width: '22px', height: '2px', backgroundColor: '#777', marginBottom: '5px', transition: '0.3s' }}></div>
          <div style={{ width: '22px', height: '2px', backgroundColor: '#777', transition: '0.3s' }}></div>
        </button>
      </div>
      {/* Mobile Nav */}
      {mobileOpen && (
        <div style={{ backgroundColor: '#404040', padding: '10px 0' }} className="mobile-nav">
          {navItems?.map((item) => (
            <a
              key={item?.label}
              href={item?.href}
              onClick={() => { setActiveItem(item?.label); setMobileOpen(false); }}
              style={{
                display: 'block',
                padding: '12px 20px',
                fontSize: '12px',
                letterSpacing: '1px',
                textDecoration: 'none',
                color: '#ddd',
                fontWeight: 700,
                textTransform: 'uppercase',
                fontFamily: 'Lato, sans-serif',
                borderTop: '1px solid rgba(120,120,120,0.2)',
              }}
            >
              {item?.label}
            </a>
          ))}
        </div>
      )}
      <style jsx>{`
        .nav-link:hover { color: #0e6585 !important; }
        @media (max-width: 768px) {
          .desktop-nav { display: none !important; }
          .mobile-menu-btn { display: block !important; }
        }
      `}</style>
    </div>
  );
}
